/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import HeadingButton from '../../components/Atoms/KycComponent/HeadingButton'
import SearchBar from '../../components/Atoms/SearchBar/SearchBar'
import { alertActions, coinManagementActions, userManagementActions } from '../../_actions'
import { useDispatch, useSelector } from 'react-redux'
import Pagination from '../../components/Pagination/Pagination'
import NoData from '../../components/Atoms/NoData'
import RedeemAmountIndividualCard from './components/RedeemAmountIndividualCard'
import ActionPopup from '../../components/Atoms/ActionPopup/ActionPopup'
import moment from 'moment'
import ViewHistoryModal from '../../components/Atoms/popup/ViewHistoryModal'
import { useLocation, useNavigate } from 'react-router'
import Loader from '../../components/Atoms/Loader'
import { compressAndResizeImage } from '../../_helpers'

import useDebounce from '../../Custom Hooks/Debounce'

const size = 5
const RedeemAmountIndividual = () => {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const navigate = useNavigate()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get('tab');
  const [resData, setResData] = useState([])
  const [activeContent, setActiveContent] = useState(tabParam || 'pending');
  const [pageNo, setPageNo] = useState(1)
  const [keyWord, setKeyWord] = useState('')
  const debouncedKeyWord = useDebounce(keyWord, 500)
  const [activeButton, setActiveButton] = useState(tabParam || 'pending');
  const [showActionPopup, setShowActionPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false)
  const [data, setData] = useState()
  const [error, setError] = useState('');
  const [selectedData, setSelectedData] = useState({
    requestStatus: "",
    attachment: "",
    id: "",
    rejectionReason: ""
  });
  const [count, setCount] = useState([])
  function getCountList() {
    coinManagementActions.getAmountAndCount({ type: "REDEEM_AMOUNT_INDIVIDUAL" }).then((res) => {
      if (res) {
        setCount(res?.data)
      }
    }).catch((err) => console.log(err))
  }
  useEffect(() => {
    getCountList()
  }, []);


  const updateUrlParams = (tab, page) => {
    const params = new URLSearchParams();
    params.set('tab', tab);

    navigate({
      pathname: location.pathname,
      search: params.toString()
    });
  };
  useEffect(() => {
    updateUrlParams(activeButton);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeButton]);

  useEffect(() => {
    setPageNo(1);
  }, [debouncedKeyWord, activeContent]);

  const details = {
    keyWord: debouncedKeyWord,
    status: activeContent,
    fromDate: "",
    toDate: "",
    sortBy: "createdAt",
    sortOrder: "desc",
    pageNo: pageNo,
    size: size, userType: "individual"
  }

  useEffect(() => {
    dispatch(userManagementActions?.raisedRequestList(details))
  }, [debouncedKeyWord, pageNo, size, activeContent]);

  useEffect(() => {
    setResData(selector?.userManagement?.getRedeemRequestList?.list)
  }, [selector]);

  const handleStatusChange = (requestStatus, id, attachment) => {
    const reqData = { requestStatus, id, attachment }
    if (requestStatus !== "approved") {
      reqData.notes = ""
    }
    setSelectedData(reqData);
    setShowActionPopup(true);
  };

  const handleContentChange = (content) => {
    setActiveContent(content);
  };

  const getStatusDetails = (content) => {
    switch (content) {
      case 'pending':
        return { statusTitle: 'Pending', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      case 'approved':
        return { statusTitle: 'Approved', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      case 'rejected':
        return { statusTitle: 'Declined', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      case 'more-info':
        return { statusTitle: 'More Info Required', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
      default:
        return { statusTitle: 'Pending', updatedStatusDate: moment(content?.updatedAt).startOf('day').fromNow() };
    }
  };


  const onPageChange = page => {
    setPageNo(page)
  }

  const handleButtonClick = (content) => {
    setActiveButton(content);
    handleContentChange(content);
    setActiveContent(content)
  };

  const handleConfirm = () => {
    let errors = {};

    // Validation logic
    if (
      (selectedData?.requestStatus === "rejected" || selectedData?.requestStatus === "more-info") &&
      !selectedData?.rejectionReason?.trim()
    ) {
      errors.inputValue = "Please provide a reason.";
    }

    if (
      selectedData?.requestStatus === "approved" &&
      !selectedData?.attachment
    ) {
      errors.attachment = "Please upload an image.";
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    // Build API payload based on requestStatus
    let apiPayload = {
      requestStatus: selectedData?.requestStatus,
      id: selectedData?.id,
      ...(selectedData?.requestStatus === "approved"
        ? { attachment: selectedData?.attachment }
        : { notes: selectedData?.rejectionReason }),
    };

    // Make API call
    setLoading(true)
    userManagementActions
      .raisedRequestUpdateStatus(apiPayload)
      .then((response) => {
        if (response) {
          dispatch(userManagementActions?.raisedRequestList(details));
          getCountList();
          dispatch(alertActions.success(response?.message || "Success."));

          setSelectedData({
            requestStatus: "",
            attachment: "",
            id: "",
          });
          setError({});
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err));
      }).finally(() => {
        setLoading(false)

      });

    setShowActionPopup(false);
  };



  const handleClose = () => {
    setShowActionPopup(false)
    setSelectedData({
      requestStatus: "",
      id: "",
      attachment: ""
    })
    setImage("")
    setError({})
  };


  const [image, setImage] = useState(null);

  const imageUpload = async (e) => {
    const file = e.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!file || !allowedTypes.includes(file.type)) {
      setError((prev) => ({ ...prev, attachment: "This file does not support upload. Only JPEG, PNG, or  GIF types are allowed." }));
      return;
    }
    setLoading(true);
    try {
      const processedFile = await compressAndResizeImage(file);
      setImage(URL.createObjectURL(processedFile));
      const res = await userManagementActions.uploadImageAPI(processedFile);
      console.log("res", res);
      dispatch(alertActions.success(res?.message));
      setSelectedData((prev) => ({
        ...prev,
        attachment: res.data.imageURL,
      }));
      setError((prev) => ({ ...prev, attachment: "" }));
    } catch (err) {
      console.log("error", err);
      dispatch(alertActions.error(err || "Failed to upload image."));
    } finally {
      setLoading(false);
      if (e.target) {
        e.target.value = "";
      }
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    setSelectedData((prev) => ({
      ...prev,
      attachment: "",
    }));

  };

  const handleViewAction = (alldata) => {
    setData(alldata);
    setIsViewModal(true)
  };


  const { statusTitle, updatedStatusDate } = getStatusDetails(activeContent);
  return (
    <>
      <Loader loading={selector?.userManagement?.loading || loading} />
      <div className='p-6 space-y-2 overflow-hidden overflow-y-auto bg-gray-50'>
        <HeadingButton
          Heading='Redeem Amount (Individual)'
          showMoreInfo={false}
          activeContent={activeContent}
          pendingCount={count?.pendingCount}
          approvedCount={count?.approvedCount}
          declinedCount={count?.rejectedCount}
          moreInfoCount={count?.moreInfoCount}
          handleButtonClick={handleButtonClick}
          activeButton={activeButton} />
        <SearchBar searchTerm={keyWord} setSearchTerm={setKeyWord} />
        {activeButton === 'pending' ? (resData && resData.filter(ele => ele?.requestStatus === 'pending').length > 0) ? (
          resData.filter(ele => ele?.requestStatus === 'pending').map((ele, idx) => (
            <div className='space-y-3' key={idx}>
              <RedeemAmountIndividualCard
                accountName={ele?.bankAccountDetails?.accountHolderName}
                accountNumber={ele?.bankAccountDetails?.accountNumber}
                ifscCode={ele?.bankAccountDetails?.ifscCode}
                bankName={ele?.bankAccountDetails?.bankName}
                accountType={ele?.bankAccountDetails?.accountType}
                branch={ele?.bankAccountDetails?.branch}
                accountCurrency={ele?.bankAccountDetails?.currencyName}
                bankAddress={ele?.bankAccountDetails?.branch}
                totalRedeem={ele?.summary?.totalRedeemAmount}
                redeemFees={ele?.fees?.redeemFees}
                knowledgeFees={ele?.fees?.knowledgeFees}
                innovationFees={ele?.fees?.innovationFees}
                rate={ele?.summary?.rate}
                statusTitle={statusTitle}
                updatedStatusDate={updatedStatusDate}
                handleReject={() => handleStatusChange("rejected", ele._id)}
                handleApprove={() => handleStatusChange("approved", ele._id)}
                handleMoreInfo={() => handleStatusChange("more-info", ele._id)}
                verifiedBy={ele?.verifiedBy}
                handleAction={handleViewAction}
                id={ele?._id}
                userId={ele?.userId}
                fees={ele?.fees}
                summary={ele?.summary}
                amountInCurrency={ele?.amountInCurrency}
                notes={ele?.notes}
                requestStatus={ele?.requestStatus}
                attachment={ele?.attachment}
                updatedAt={ele?.updatedAt}
                allData={ele}
              />
            </div>
          ))
        ) : (
          <NoData />
        ) : null}
        {activeButton === 'approved' ? (resData && resData.filter(ele => ele?.requestStatus === 'approved').length > 0) ? (
          resData.filter(ele => ele?.requestStatus === 'approved').map((ele, idx) => (
            <div className='space-y-3' key={idx}>
              <RedeemAmountIndividualCard
                accountName={ele?.bankAccountDetails?.accountHolderName}
                accountNumber={ele?.bankAccountDetails?.accountNumber}
                ifscCode={ele?.bankAccountDetails?.ifscCode}
                bankName={ele?.bankAccountDetails?.bankName}
                accountType={ele?.bankAccountDetails?.accountType}
                branch={ele?.bankAccountDetails?.branch}
                accountCurrency={ele?.bankAccountDetails?.currencyName}
                bankAddress={ele?.bankAccountDetails?.branch}
                totalRedeem={ele?.summary?.totalRedeemAmount}
                redeemFees={ele?.fees?.redeemFees}
                knowledgeFees={ele?.fees?.knowledgeFees}
                innovationFees={ele?.fees?.innovationFees}
                rate={ele?.summary?.rate}
                statusTitle={statusTitle}
                updatedStatusDate={updatedStatusDate}
                handleReject={() => handleStatusChange("rejected", ele._id)}
                handleApprove={() => handleStatusChange("approved", ele._id)}
                handleMoreInfo={() => handleStatusChange("more-info", ele._id)}
                verifiedBy={ele?.verifiedBy}
                handleAction={handleViewAction}
                id={ele?._id}
                userId={ele?.userId}
                fees={ele?.fees}
                summary={ele?.summary}
                amountInCurrency={ele?.amountInCurrency}
                notes={ele?.notes}
                requestStatus={ele?.requestStatus}
                attachment={ele?.attachment}
                updatedAt={ele?.updatedAt}
                allData={ele}

              />
            </div>
          ))
        ) : (
          <NoData />
        ) : null}


        {activeButton === 'rejected' ? (resData && resData.filter(ele => ele?.requestStatus === 'rejected').length > 0) ? (
          resData.filter(ele => ele?.requestStatus === 'rejected').map((ele, idx) => (
            <div className='space-y-3' key={idx}>
              <RedeemAmountIndividualCard
                accountName={ele?.bankAccountDetails?.accountHolderName}
                accountNumber={ele?.bankAccountDetails?.accountNumber}
                ifscCode={ele?.bankAccountDetails?.ifscCode}
                bankName={ele?.bankAccountDetails?.bankName}
                accountType={ele?.bankAccountDetails?.accountType}
                branch={ele?.bankAccountDetails?.branch}
                accountCurrency={ele?.bankAccountDetails?.currencyName}
                bankAddress={ele?.bankAccountDetails?.branch}
                totalRedeem={ele?.summary?.totalRedeemAmount}
                redeemFees={ele?.fees?.redeemFees}
                knowledgeFees={ele?.fees?.knowledgeFees}
                innovationFees={ele?.fees?.innovationFees}
                rate={ele?.summary?.rate}
                statusTitle={statusTitle}
                updatedStatusDate={updatedStatusDate}
                handleReject={() => handleStatusChange("rejected", ele._id)}
                handleApprove={() => handleStatusChange("approved", ele._id)}
                handleMoreInfo={() => handleStatusChange("more-info", ele._id)}
                verifiedBy={ele?.verifiedBy}
                handleAction={handleViewAction}
                id={ele?._id}
                userId={ele?.userId}
                fees={ele?.fees}
                summary={ele?.summary}
                amountInCurrency={ele?.amountInCurrency}
                notes={ele?.notes}
                requestStatus={ele?.requestStatus}
                attachment={ele?.attachment}
                updatedAt={ele?.updatedAt}
                allData={ele}
              />
            </div>
          ))
        ) : (
          <NoData />
        ) : null}
      </div>

      <ActionPopup
        inputValue={selectedData?.notes ?? null}
        handleInputValue={(value) => setSelectedData(prev => ({
          ...prev, notes: value
        }))}
        handleConfirm={handleConfirm}
        onClose={handleClose}
        showActionPopup={showActionPopup}
        heading={`Are you sure you want to ${selectedData?.requestStatus === 'approved' ? 'approve' : selectedData?.requestStatus}?`}
        showInput={false}
        inputPlaceholder="Enter rejection reason..."
        imageUrl='/warning.png'
        statusHeading={selectedData?.requestStatus}
        inputError={error}
        handleImageUpload={imageUpload}
        image={image}
        handleRemoveImage={handleRemoveImage}
        showImage={true}
        loading={loading}
        isNote={selectedData?.requestStatus === "rejected" || selectedData?.requestStatus === "more-info"}
        noteValue={selectedData?.rejectionReason}
        noteChange={(value) =>
          setSelectedData((prev) => ({
            ...prev,
            rejectionReason: value
          }))
        }

      />

      {Math.ceil((selector?.userManagement?.getRedeemRequestList?.total || 0) / size) > 1 && (
        <Pagination
          totalPages={Math.ceil((selector?.userManagement?.getRedeemRequestList?.total || 0) / size)}
          currentPage={pageNo}
          onPageChange={onPageChange} />
      )}


      <ViewHistoryModal
        isOpen={isViewModal}
        onClose={() => { setIsViewModal(false); setData([]) }}
        heading="History"
        data2={data}
        isNotesData={true}
        isApiResData={false}

      />
    </>
  )
}

export default RedeemAmountIndividual